// used in many places and was importing whole of this component so moved here.
// because it was building huge dependencies tree that was required to be mocked in tests
export const pathnamePrestepNoPermissions = '/no-permissions';
